import { Swiper } from 'swiper';
import { Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import '../../css/swiper-custom.css';

export default function solutionCardCarousel() {
  return {
    swiper: null,
    currentIndex: 0,

    init() {
      this.$nextTick(() => {
        this.initSwiper();
      });
    },

    initSwiper() {
      if (!this.$refs.swiper || !this.$refs.pagination) return;

      this.swiper = new Swiper(this.$refs.swiper, {
        modules: [Pagination, A11y],

        // Responsive breakpoints
        slidesPerView: 1.1,
        spaceBetween: 16,
        centeredSlides: true,

        breakpoints: {
          640: {
            slidesPerView: 1.4,
            spaceBetween: 24,
            centeredSlides: true,
          },
          1024: {
            slidesPerView: 1.1,
            spaceBetween: 32,
            centeredSlides: true,
          }
        },

        // Pagination
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
          type: 'bullets'
        },

        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          slideLabelMessage: '{{index}} / {{slidesLength}}',
          containerMessage: 'Solution cards carousel',
          containerRoleDescriptionMessage: 'carousel',
          itemRoleDescriptionMessage: 'slide'
        },

        // Touch settings
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,

        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        // Events
        on: {
          slideChange: () => {
            this.currentIndex = this.swiper.activeIndex;
          },
          init: () => {
            this.currentIndex = 0;
          }
        }
      });
    },

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },

    get totalSlides() {
      return this.swiper ? this.swiper.slides.length : 0;
    },

    get isFirstSlide() {
      return this.currentIndex === 0;
    },

    get isLastSlide() {
      return this.currentIndex === this.totalSlides - 1;
    }
  };
}
